import { Action } from '@ngrx/store';
import { ColorBusiness } from '@app/models/color-business';

export enum ColorBusinessActionTypes {
  Load = '[ColorBusiness] Load',
  LoadSuccess = '[ColorBusiness] Load Success',
  LoadFail = '[ColorBusiness] Load Fail',

  Create = '[ColorBusiness] Create colorBusiness',
  CreateSuccess = '[ColorBusiness] Create colorBusiness success',
  CreateFail = '[ColorBusiness] Create colorBusiness fail',

  AddOne = '[ColorBusiness] Add one',
  AddAll = '[ColorBusiness] Add all',

  Update = '[ColorBusiness] Update colorBusiness',
  UpdateSuccess = '[ColorBusiness] Update colorBusiness success',
  UpdateFail = '[ColorBusiness] Update colorBusiness fail',
  UpdateOne = '[ColorBusiness] Update one',

  Delete = '[ColorBusiness] delete',
  DeleteSuccess = '[ColorBusiness] delete success',
  DeleteFail = '[ColorBusiness] delete fail'
}

export class Load implements Action {
  readonly type = ColorBusinessActionTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = ColorBusinessActionTypes.LoadSuccess;
  constructor(public colorBusiness: ColorBusiness[]) {}
}

export class LoadFail implements Action {
  readonly type = ColorBusinessActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class Create implements Action {
  readonly type = ColorBusinessActionTypes.Create;
  constructor(public colorBusiness: ColorBusiness) {}
}

export class CreateSuccess implements Action {
  readonly type = ColorBusinessActionTypes.CreateSuccess;
  constructor(public colorBusiness: ColorBusiness) {}
}

export class CreateFail implements Action {
  readonly type = ColorBusinessActionTypes.CreateFail;
  constructor(public error: any) {}
}
export class AddAll implements Action {
  readonly type = ColorBusinessActionTypes.AddAll;
  constructor(public colorBusiness: ColorBusiness[]) {}
}

export class AddOne implements Action {
  readonly type = ColorBusinessActionTypes.AddOne;
  constructor(public colorBusiness: ColorBusiness) {}
}
export class Update implements Action {
  readonly type = ColorBusinessActionTypes.Update;
  constructor(public id: number, public colorBusiness: ColorBusiness) {}
}
export class UpdateFail implements Action {
  readonly type = ColorBusinessActionTypes.UpdateFail;
  constructor(public error: any) {}
}

export class UpdateSuccess implements Action {
  readonly type = ColorBusinessActionTypes.UpdateSuccess;
  constructor(public id: number, public data: any) {}
}

export class UpdateOne implements Action {
  readonly type = ColorBusinessActionTypes.UpdateOne;
  constructor(public colorBusiness: ColorBusiness) {}
}

export class Delete implements Action {
  readonly type = ColorBusinessActionTypes.Delete;
  constructor(public id: number) {}
}

export class DeleteSuccess implements Action {
  readonly type = ColorBusinessActionTypes.DeleteSuccess;
  constructor(public id: number) {}
}
export class DeleteFail implements Action {
  readonly type = ColorBusinessActionTypes.DeleteFail;
  constructor(public error: any) {}
}

export type ColorBusinessActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | Create
  | CreateSuccess
  | CreateFail
  | AddOne
  | AddAll
  | Update
  | UpdateFail
  | UpdateSuccess
  | UpdateOne
  | Delete
  | DeleteSuccess
  | DeleteFail;
